import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 1190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 22390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 2190,
    rating:2,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2390,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 3290,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 4390,
        rating:1,
  },
  {_id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 5690,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 5490,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 6590,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 1390,
    rating:3,
  },
  
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 3190,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 3790,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 790,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 890,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 901,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 902,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 930,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 910,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 190,
    rating:3,
  },
  {
    _id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 20,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 390,
    rating:3,
  },
  {_id: uuid(),
    category:"Collectibles",
    title:"Hyperbeast Collector's bundle",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/NendoroidWattson-Sitting_800x.jpg?v=1645840280",
    desc:'"Papa would be proud of me."To the Nendoroid series comes the Static Defender Wattson."',
    price: 590,
    rating:4,
  },
  {
    _id: uuid(),
        category:"Accessories",
        title:"MAD MAGGIE JACKET",
        img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Waterbottle-Front_800x.png?v=1643842041",
        desc:"Re-charge your shields with this Phoenix Kit inspired water bottle!",
        price: 2290,
        rating:5,
  },
  {
    _id: uuid(),
    category:"Apparel",
    title:"MAD MAGGIE JACKET",
    img:"https://cdn.shopify.com/s/files/1/1796/6745/products/Apex-Maggie-Jacket-Front_800x.png?v=1644057091",
    desc:"Intimidate your enemies with Mad Maggie’s durable denim jacket, featuring patch artwork.",
    price: 4490,
    rating:3,
  },
];
